import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaAtendimentoPf } from './types';

export const INITIAL_STATE: ConsultaAtendimentoPf = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaAtendimentoPf {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_ATENDIMENTO_PF_REQUEST: {
				break;
			}
			case Types.CONSULTA_ATENDIMENTO_PF_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_ATENDIMENTO_PF_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_ATENDIMENTO_PF_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
